import {
    Container,
    Paper,
    Typography,
    Box,
    TextField,
    Button,
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    FormHelperText
} from "@mui/material";
import FileUpload from "../application/FileUpload";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function AuthorityToWorkForm({

    data,

    errors,

    handleChange,

    handleFileChange,

    onBack,

    onContinue

}) {

    return (


            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Authority to Work in the UK

                </Typography>

                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)", }}>

                    Please provide your right to work information.

                </Typography>


                <Box

                    sx={{
                        display: "grid",
                        gap: 2,
                        mb: 4,
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1fr"
                        }
                    }}

                >

                    <TextField

                        label="Nationality"

                        name="nationality"

                        value={data.nationality}

                        onChange={handleChange}

                        error={!!errors.nationality}

                        helperText={errors.nationality}

                    />

                    <TextField

                        label="Passport Number"

                        name="passportNumber"

                        value={data.passportNumber}

                        onChange={handleChange}

                        error={!!errors.passportNumber}

                        helperText={errors.passportNumber}

                    />

                </Box>


                <FormControl
                    error={!!errors.requiresVisaWorkPermit}
                    sx={{ mb: 3 }}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                        Do you need a Visa / Work Permit?

                    </FormLabel>

                    <RadioGroup

                        row

                        name="requiresVisaWorkPermit"

                        value={data.requiresVisaWorkPermit}

                        onChange={handleChange}

                    >

                        <FormControlLabel

                            value="true"

                            control={<Radio />}

                            label="Yes"

                        />

                        <FormControlLabel

                            value="false"

                            control={<Radio />}

                            label="No"

                        />

                    </RadioGroup>

                    <FormHelperText>

                        {errors.requiresVisaWorkPermit}

                    </FormHelperText>

                </FormControl>


                {data.requiresVisaWorkPermit === "true" && (

                    <>

                        <TextField

                            fullWidth

                            sx={{ mb: 3 }}

                            label="Visa Expiry Date"

                            type="date"

                            name="visaExpiryDate"

                            value={data.visaExpiryDate}

                            onChange={handleChange}

                            InputLabelProps={{
                                shrink: true
                            }}

                            inputProps={{
                                min: new Date().toISOString().split("T")[0]
                            }}

                            error={!!errors.visaExpiryDate}

                            helperText={errors.visaExpiryDate}

                        />

                        <FileUpload
                            label="Upload Visa / Work Permit"
                            file={data.visaDocument}
                            onChange={(file) =>
                                handleFileChange(
                                    "visaDocument",
                                    file
                                )
                            }
                            acceptedTypes={[
                                "application/pdf",
                                "image/jpeg",
                                "image/png"
                            ]}
                            maxFileSize="10MB"
                            error={errors.visaDocument}
                        />

                    </>

                )}


                <Box

                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 5
                    }}

                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>

    );

}